import { CustomCellRendererProps } from 'ag-grid-react';

import { ColumnCellValue } from '../../../../modules/market-mapping-content/components/market-mapping-content.styles';
import Link from '../../link/base-link/base-link.component';

export function LinkCellRenderer(props: { value: string }) {
  const { value } = props;
  return <Link url={value} title={value} target="_blank" sx={{ textDecoration: 'underline' }} />;
}

export function ShortUrlCellRenderer(params: CustomCellRendererProps) {
  const { data } = params;
  return <ColumnCellValue sx={{ fontSize: '14px' }}>{data.url}</ColumnCellValue>;
}
